var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ExportService } from '../../../../services/export.csv.service';
import { HubApiService } from '../../../../services/hub.api.service';
import { HubExportPdfStore } from '../../../../stores/hub.calendar.store';
import { EditTourTitleModalActions, EditTourTitleModalData } from './edit.tour.title.modal.provider';
import { BaseComponent } from '../../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
var EditTourTitleModalComponent = /** @class */ (function (_super) {
    __extends(EditTourTitleModalComponent, _super);
    function EditTourTitleModalComponent(dialogRef, actions, hubApiService, exportService, formBuilder, exportPdfStore, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.hubApiService = hubApiService;
        _this.exportService = exportService;
        _this.formBuilder = formBuilder;
        _this.exportPdfStore = exportPdfStore;
        _this.data = Object.assign({}, data);
        _this.editTourTitleFormGroup = _this.formBuilder.group({
            'title': [null, [Validators.required]],
            'description': [null, []]
        });
        return _this;
    }
    EditTourTitleModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    EditTourTitleModalComponent.prototype.confirm = function (event) {
        var _this = this;
        if (this.data.isAsync) {
            var oldFunc_1 = event.complete;
            event.complete = function () {
                oldFunc_1();
                _this.dialogRef.close();
            };
            this.hubApiService.updateTourTitleAndDescription(this.data.hubName, this.data.id, this.data.title, this.data.description)
                .subscribe(function () {
                _this.actions.confirm(event, _this.data.title, _this.data.description);
                event.complete();
            });
        }
        else {
            this.actions.confirm(event, this.data.title, this.data.description);
            this.dialogRef.close();
        }
    };
    return EditTourTitleModalComponent;
}(BaseComponent));
export { EditTourTitleModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/tours/edit.tour.title.modal/edit.tour.title.modal.component.ts.pre-build-optimizer.js